module.exports = __webpack_public_path__ + "static/media/Rob Allen.b4b6dc15.jpg";